import { render, staticRenderFns } from "./teamDetail.vue?vue&type=template&id=66507f5f&scoped=true"
import script from "./teamDetail.vue?vue&type=script&lang=js"
export * from "./teamDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66507f5f",
  null
  
)

export default component.exports